import "rsuite/dist/rsuite.min.css";
import React, { useEffect, useState, useContext, useRef } from "react";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import "../main.css";
import Layout from "components/sales/layout/layout";
import Images from "assets/images/imageData";
import "./monthlyvaletsalaryV1.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ModalPop from "components/sales/modal/modal";
import Multiselect from 'multiselect-react-dropdown';
import ReactPaginate from "react-paginate";
import { toast } from 'react-toastify';

const MonthlyValetSalary = ({
  history,
  getMonthlyDataForValet,
  getValetMonthlyList = {},
  calculateSalaryForValet,
  calulateSalary = {},
  dailyValetSalaryDistribution,
  getDailySalaryDistribution = {},
  updateSalaryStatusForValet,
  valetPenaltyListing,
  penaltyList=[],
  match,
  masterSalaryPenaltyListRequest,
  masterSalaryPenaltyListResponse=[]
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isChecked, setIsChecked] = useState([false]);
  const [isFreezeModal, setIsFreezeModal] = useState(false);
  const [isCalculateModal, setIsCalculateModal] = useState(false);
  const [error, setError] = useState("");
  const [isModalFailed, setIsModalFailed] = useState(false);
  const [calculateSalaryModal, setCalculateSalaryModal] = useState(false);
  const [dailySalaryModal, setDailySalaryModal] = useState(false);
  const [userMasterPenaltyModal, setUserMasterPenaltyModal] = useState(false);
  const [penaltyDetailsModal, setPenaltyDetailsModal] = useState(false);
  const [freezeId, setFreezeId] = useState(false);
  const [inputFields, setInputFields] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [transposedData, setTransposeData] = useState([]);
  const [incentiveList, setIncentiveList] = useState([]);
  const [gridData, setGridData] = useState([]);
  const options = [
    { id: "Referral Bonus", name: "Referral Bonus" },
    { id: "Festival Benefits", name: "Festival Benefits" },
    { id: "Arrears", name: "Arrears" },
    { id: "Weekend Duty", name: "Weekend Duty" },
    { id: "Others", name: "Others" }
  ];

  const [optionsMonetary, setOptionsMonetary] = useState([
    { id: "Referral Bonus",  name: "Referral Bonus" },
    { id: "Festival Benefits", name: "Festival Benefits" },
    { id: "Arrears", name: "Arrears" },
    { id: "Weekend Duty", name: "Weekend Duty" },
    { id: "Others", name: "Others" }
  ])

  const [optionsPenalty, setOptionsPenalty] = useState([
    { id: "Car image fraud", name: "Car image fraud" },
    { id: "Vehicle number fraud", name: "Vehicle number fraud" },
    { id: "Mobile number fraud", name: "Mobile number fraud" },
    { id: "Drive+ penalty", name: "Drive+ penalty" },
    { id: "Grooming / Non-Uniform", name: "Grooming / Non-Uniform" },
    { id: "Late coming", name: "Late coming" },
    { id: "Car damage", name: "Car damage" },
    {
      id: "Tobacco/substance consumption",
      name: "Tobacco/substance consumption",
    },
    { id: "Photo audit failure", name: "Photo audit failure" },
    { id: "Disciplinary action", name: "Disciplinary action" },
    { id: "Others", name: "Others" },
  ]);

  const getMonthName = (month) => {
    const monthNames = [
      "",
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];
    return monthNames[month];
  };


  const handleCheckboxChange = (checked, index) => {
    isChecked[index] = checked;
    setFreezeId(index);
    if (checked) {
      setIsFreezeModal(true);
    } else {
      setIsFreezeModal(false);
    }
    setTimeout(() => {
      setIsLoading(true);
      setIsChecked(isChecked);
      setIsLoading(false);
    }, 100);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if (match?.params?.phone !== undefined && match?.params?.phone !== null) {
        await getMonthlyDataForValet(1,match?.params?.phone, null, match?.params?.status, match?.params?.month, match?.params?.year);
      } else {
        await getMonthlyDataForValet(1,null, null, null);
      }
      setIsLoading(false);
    })();
  }, []);

  // useEffect(() => { 
  //   if (
  //     penaltyList !== undefined &&
  //     penaltyList !== null &&
  //     penaltyList !== ""
  //   ) {
  //     // console.log("sdjfhs",penaltyList);
  //     setIncentiveList(penaltyList);
  //     setGridData(penaltyList?.grid_data);
  //   }
  // }, [penaltyList]);

  useEffect(() => {
    const allowedKeys = ["USER_AVAILABILITY","OVER_SPEEDING", "HARD_BRAKING", "HIGH_ACCELERATION"];
    const newTransposedData =
      incentiveList?.grid_data && incentiveList.grid_data.length > 0
        ? incentiveList.grid_data.reduce((acc, rowData) => {
            Object.keys(rowData.penalties_breakdown_data).filter((key) => allowedKeys.includes(key)).forEach((earningType) => {
              if (!acc[earningType]) {
                acc[earningType] = [];
              }
              acc[earningType].push({
                transaction_date: rowData.transaction_date,
                earning_id: rowData.penalties_breakdown_data[earningType].earning_id,
                total_amount_approved:
                  rowData.penalties_breakdown_data[earningType].total_amount_approved,
                total_amount_earned:
                  rowData.penalties_breakdown_data[earningType].total_amount_earned,
                status: rowData.penalties_breakdown_data[earningType].status,
                is_processed: rowData.penalties_breakdown_data[earningType].is_processed,
                is_checked: rowData.penalties_breakdown_data[earningType].is_checked,
              });
            });
            return acc;
          }, {})
        : {};

    setTransposeData(newTransposedData);
  }, [incentiveList]);

  const handleDailySalaryDistribution = async (
    montlySalaryId,
    userName,
    status
  ) => {
    const payload = {
      valet_monthly_salary_id: montlySalaryId,
      user_name: userName,
      status: status,
    };
    setIsLoading(true);
    await dailyValetSalaryDistribution(payload);
    setDailySalaryModal(payload?.valet_monthly_salary_id);
    setIsLoading(false);
    return false;
  };
  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const day = dateObject.getDate().toString().padStart(2, "0");
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  };

  function getDateRange(month, year) {
    // Calculate the previous month and year
    const previousMonth = month === 1 ? 12 : month - 1;
    const previousYear = month === 1 ? year - 1 : year;

    // Get the start date (26th of the previous month)
    const startDate = new Date(previousYear, previousMonth - 1, 27);

    // Get the end date (25th of the provided month)
    const endDate = new Date(year, month - 1, 26);

    return {
        startDate: startDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
        endDate: endDate.toISOString().split("T")[0],     // Format as YYYY-MM-DD
    };
}

  const handlePenaltyDetailsData = async (
      userId, penaltyMonth, penaltyYear
  ) => {
    const { startDate, endDate } = getDateRange(penaltyMonth, penaltyYear);
      // const today = new Date();
      // const firstDate = new Date(today.getFullYear(), today.getMonth(), 1);
      // const date = new Date(firstDate);
      // const year = date.getFullYear();
      // const month = ("0" + (date.getMonth() + 1)).slice(-2);
      // const day = ("0" + date.getDate()).slice(-2);
      // const formatFirstDate = `${year}-${month}-${day}`;

      // const todayDate = today.toISOString().split("T")[0];
      setIsLoading(true);
      setPenaltyDetailsModal(true)
      const res = await valetPenaltyListing(
        userId,
        startDate,
        endDate,
        2,
        1
      );
      setIncentiveList(res);
      setGridData(res?.grid_data);
      setIsLoading(false);
    return false;
  };


  const handleCalculate = async (id,index) => {
    const updatedFields = [...inputFields];

    const payload = {
      data: updatedFields[index],
      id: id,
    };
    setIsLoading(true);
    const res = await calculateSalaryForValet(payload);
    if (res.status) {
      setCalculateSalaryModal(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleCalculateFreeze = async (salaryId) => {
    const payload = {
      monthly_salary_record_id: [salaryId],
      status: "OPS_FREEZED",
    };
    setIsLoading(true);
    const res = await updateSalaryStatusForValet(payload);
    if (res.status) {
      toast.success("Salary freezed successfully!");
      history.push('/dashboard/salary-master');  
    } else {
      toast.error("Failed to freeze salary!");
      history.push('/dashboard/salary-master');
    }
    setIsLoading(false);
  };
  
  const handleCalculateModalHide = () => {
    setIsCalculateModal(false);
    setError(""); 
    window.location.reload();
  };

  const handlesetCalculateSalaryModalHide = () => {
    setCalculateSalaryModal(false);
    window.location.reload();
  };

  const handleFreezeModalHide = () => {
    setIsFreezeModal(false);
    setError("");
    window.location.reload();
  };

  useEffect(() => {
    if (getValetMonthlyList && getValetMonthlyList?.resultSets && Object.keys(getValetMonthlyList).length > 0 ) {
      setInputFields(getValetMonthlyList?.resultSets)
     
      getValetMonthlyList?.resultSets?.map((val, index) => {
        if (!isChecked[index]) {
          isChecked[index] = false;
        }
      });
      setIsChecked(isChecked);
    }
  }, [getValetMonthlyList]);

  const handleFailedModalHide = () => {
    setIsModalFailed(false);
    setError(""); 
    window.location.reload();
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getMonthlyDataForValet(val.selected + 1, match?.params?.phone, null, match?.params?.status, match?.params?.month, match?.params?.year);
    setIsLoading(false);
  };

  const handleDailyModalCloseClick = () => {
    setDailySalaryModal(false);
    window.location.reload();
  };

  const handleUserPenaltyModalCloseClick = () => {
    setUserMasterPenaltyModal(false);
    window.location.reload();
  };
  const handlePenaltyDetailsModalCloseClick = () => {
    setPenaltyDetailsModal(false);
  };


  useEffect(() => {
    setIsLoading(true);
    setPageCount(Math.ceil(getValetMonthlyList.total / getValetMonthlyList.per_page));
    setIsLoading(false);
  }, [getValetMonthlyList] )


  const handleSelectChange = (key,selectedOptions, index) => {
    const monetaryUpdatedAmount = [...inputFields];
    monetaryUpdatedAmount[index][key] = selectedOptions;
    setInputFields(monetaryUpdatedAmount);
    return false;
  };

  const handleInputChange = (field, value, index) => {
    const updatedFields = [...inputFields];
    updatedFields[index][field] = value;
    setInputFields(updatedFields);
  };  

  

  const handleUserPenalty = async (id) => {
    setIsLoading(true);
    setUserMasterPenaltyModal(true);
    await masterSalaryPenaltyListRequest(id)
    setIsLoading(false)
  }
  
  return (
    <>
      <Layout
        title={localization.monthlyValetSalary}
        isGoback
        isLoading={isLoading}
        linkFlag
        linkUrl={`${baseUrl}/salary-master`}
      >
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
        />
        <>
          {inputFields && inputFields?.length > 0 ? (
            <>
            <div className="cdx" style={{ overflowX: "auto" }}>
              <table className="monthly-salary-table">
                <thead className="fix-head">
                  <tr className="table-heading v3Tab monthly-table-row">
                    <th className="monthly-table-head fx-tab">S.No.</th>
                    <th className="monthly-table-head fx-tab">Month</th>
                    <th className="monthly-table-head fx-tab">Year</th>
                    <th className="monthly-table-head fx-tab">Driver name</th>
                    <th className="monthly-table-head">Total Calendar Days</th>
                    <th className="monthly-table-head">Week-offs</th>
                    <th className="monthly-table-head">Holidays</th>
                    <th className="monthly-table-head">Expected Working Days</th>
                    <th className="monthly-table-head">Full Duty Days</th>
                    <th className="monthly-table-head">Half Duty Days</th>
                    <th className="monthly-table-head">Actual Approved Overtime Hours</th>
                    <th className="monthly-table-head">View day wise</th>
                    <th className="monthly-table-head">Weekoff Amount</th>
                    <th className="monthly-table-head">Holiday Amount</th>
                    <th className="monthly-table-head">Full Day Duty Amount</th>
                    <th className="monthly-table-head">Half Day Duty Amount</th>
                    {/* <th className="monthly-table-head">
                      Zero days extra hours
                    </th>
                    <th className="monthly-table-head">
                      Amount for zero days extra hours
                    </th> */}
                    <th className="monthly-table-head">Overtime Amount</th>
                    <th className="monthly-table-head">Bonus Amount</th>
                    <th className="monthly-table-head">Travel Benefit</th>
                    <th className="monthly-table-head">Insurance Amount</th>
                    <th className="monthly-table-head">Hold Line Amount</th>
                    <th className="monthly-table-head">Advance Paid</th>
                    {/* <th className="monthly-table-head">Half day extra hours</th>
                    <th className="monthly-table-head">
                      Amount for half day extra hours
                    </th> */}
                    <th className="monthly-table-head">
                      System Generated Penalty
                    </th>
                    <th className="monthly-table-head">
                      Approved Penalty
                    </th>
                    <th className="monthly-table-head">
                      {/*Any Other Penalty check*/}
                      AE Suggested Penalties
                    </th>
                    {/*<th className="monthly-table-head">Any other penalty</th>*/}
                    <th className="monthly-table-head"> Approved AE Penalty</th>
                    <th className="monthly-table-head">Extra monetary check</th>
                    <th className="monthly-table-head">
                      Extra monetary benifit
                    </th>
                    <th className="monthly-table-head">Base salary</th>
                    <th className="monthly-table-head">Overtime Rate</th>
                    <th className="monthly-table-head">Status</th>
                    <th className="monthly-table-head">Finance Remarks</th>
                    <th className="monthly-table-head">Refferal Bonus Amount</th>
                    <th className="monthly-table-head">Calculate</th>
                    <th className="monthly-table-head">Net Amount</th>
                    <th className="monthly-table-head">Final approve</th>
                    <th className="monthly-table-head">View Penalty Details</th>
                  </tr>
                </thead>
                <tbody>
                  { inputFields?.map((item, index) => (
                    <>
                      <tr className="monthly-table-row" key={index}>
                      <td className="monthly-table-data fx-tab-2">
                        <b>
                        {parseInt(getValetMonthlyList?.current_page) === 1 ? index+1 + '.' : 15*(parseInt(getValetMonthlyList?.current_page)-1)+(1+index)+'.'}
                        </b>
                      </td>
                        <td className="monthly-table-data fx-tab-2">
                          {getMonthName(item?.month)}
                        </td>
                        <td className="monthly-table-data fx-tab-2">
                          {item?.year}
                        </td>
                        <td className="monthly-table-data fx-tab-2">
                          {item?.user_name}
                        </td>
                        <td className="monthly-table-data">
                          {item?.calendar_days}
                        </td>
                        <td className="monthly-table-data">
                          {item?.weekoff_days}
                        </td>
                        <td className="monthly-table-data">
                          {item?.marked_holidays}
                        </td>
                        <td className="monthly-table-data">
                          {item?.expected_working_days}
                        </td>
                        <td className="monthly-table-data">
                          {item?.full_working_days}
                        </td>
                        <td className="monthly-table-data">
                          {item?.half_working_days}
                        </td>
                         <td className="monthly-table-data">
                          {/* <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={item?.approved_total_overtime_hours}
                            handleChange={(value) => handleInputChange('approved_total_overtime_hours', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          /> */}
                           {item?.approved_total_overtime_hours}
                        </td>
                        <td className="monthly-table-data">
                          <i
                            className="fa fa-eye icon-styling-v1"
                            data-toggle="modal"
                            data-target="#viewDailyModalCenter"
                            onClick={() =>
                              handleDailySalaryDistribution(item.id)
                            }
                          ></i>
                        </td>
                        <td className="monthly-table-data">
                          {item?.weekoff_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item?.holidays_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item?.full_days_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item?.half_days_amount}
                        </td>
                          {/* <td className="monthly-table-data">
                            <ConstantInput
                              className="input-field-style"
                              type="number"
                              value={item?.approved_zero_day_extra_hours}
                              handleChange={(value) => handleInputChange('approved_zero_day_extra_hours', value, index)}

                              disabled={
                                isChecked[index] ||
                                item.status === "OPS_FREEZED" ||
                                item.status === "OPS_APPROVED" ||
                                item.status === "OPS_REJECTED"
                              }
                            />
                          </td>
                          <td className="monthly-table-data">
                            <ConstantInput
                              className="input-field-style"
                              type="number"
                              value={item?.zero_day_extra_hours_amount}
                              handleChange={(value) => handleInputChange('zero_day_extra_hours_amount', value, index)}
                              disabled={
                                isChecked[index] ||
                                item.status === "OPS_FREEZED" ||
                                item.status === "OPS_APPROVED" ||
                                item.status === "OPS_REJECTED"
                              }
                            />
                          </td> */}
                       

                        {/* <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={item?.total_overtime_amount}
                            handleChange={(value) => handleInputChange('total_overtime_amount', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td> */}
                        <td className="monthly-table-data">
                          {item.overtime_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item.bonus_amount}
                        </td>
                        {/* <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={item?.approved_half_day_extra_hours}
                            handleChange={(value) => handleInputChange('approved_half_day_extra_hours', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td>
                        <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={item?.half_day_extra_hours_amount}
                            handleChange={(value) => handleInputChange('half_day_extra_hours_amount', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td> */}
                        <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={item?.travel_amount}
                            handleChange={(value) => handleInputChange('travel_amount', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td>
                        <td className="monthly-table-data">
                          {item?.insurance_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item?.blocked_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item?.advanced_salary}
                        </td>
                        <td className="monthly-table-data">
                          {item?.system_generated_penalty}
                        </td>
                        <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={inputFields[index]?.approved_system_penalty}
                            handleChange={(value) => handleInputChange('approved_system_penalty', value, index)}
                          />
                        </td>
                        <td className="monthly-table-data">
                          <i
                              className="fa fa-eye icon-styling-v1"
                              onClick={() =>
                                  handleUserPenalty(item.id)
                              }
                          ></i>
                          {/*<Multiselect*/}
                          {/*    displayValue="name"*/}
                          {/*    onSelect={(value) => {*/}
                          {/*      handleSelectChange('penalty_amount_remarks', value, index)*/}
                          {/*    }}*/}
                          {/*    onRemove={(value) => {*/}
                          {/*      handleSelectChange('penalty_amount_remarks', value, index)*/}
                          {/*    }}*/}
                          {/*    options={optionsPenalty}*/}
                          {/*    selectedValues={item?.penalty_amount_remarks ? item?.penalty_amount_remarks : []}*/}
                          {/*    style={{*/}
                          {/*      chips: {*/}
                          {/*        background: '#6c7ae0'*/}
                          {/*      },*/}
                          {/*    }}*/}

                          {/*/>*/}

                        </td>
                        <td className="monthly-table-data">
                          <ConstantInput
                              className="input-field-style"
                              type="number"
                              value={item?.penalty_amount}
                              handleChange={(value) => handleInputChange('penalty_amount', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td>
                      <td className="monthly-table-data"> 
                        {/* <Multiselect
                            displayValue="name"
                            onSelect={(value) => {
                              handleSelectChange('extra_amount_remarks', value, index);
                            }}
                            onRemove={(value) => {
                              handleSelectChange('extra_amount_remarks', value, index);
                            }}
                            options={options}
                            selectedValues={
                              item?.extra_amount_remarks_value
                                ? item.extra_amount_remarks_value.map(val =>
                                    options.find(option => option.id === val) || { id: val, name: val }
                                  )
                                : []
                            }
                            style={{
                              chips: {
                                background: '#6c7ae0'
                              }
                            }}
                          /> */}

                          <ConstantInput
                            className="input-field-style"
                            type="text"
                            value={inputFields[index]?.extra_amount_remarks}
                            handleChange={(value) => handleInputChange('extra_amount_remarks', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                          
                        </td>
                        <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={inputFields[index]?.extra_amount}
                            handleChange={(value) => handleInputChange('extra_amount', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td>
                        <td className="monthly-table-data">
                          {item?.monthly_salary}
                        </td>
                        <td className="monthly-table-data">
                          {item?.total_overtime_amount}
                        </td>
                        <td className="monthly-table-data">
                          {item?.status}
                        </td>
                        <td className="monthly-table-data">
                          {item?.finance_status_remarks}
                        </td>
                        <td className="monthly-table-data">
                          <ConstantInput
                            className="input-field-style"
                            type="number"
                            value={inputFields[index]?.metadata?.referral_bonus_amount}
                            handleChange={(value) => handleInputChange('referral_bonus_amount', value, index)}
                            disabled={
                              isChecked[index] ||
                              item.status === "OPS_FREEZED" ||
                              item.status === "OPS_APPROVED" ||
                              item.status === "OPS_REJECTED"
                            }
                          />
                        </td>
                        <td>
                          {item.status !== "OPS_FREEZED" &&
                            item.status !== "OPS_APPROVED" &&
                            item.status !== "OPS_REJECTED" && (
                              <i
                                className="fa fa-calculator icon-styling-v1"
                                data-toggle="modal"
                                onClick={() => handleCalculate(item.id,index)}
                              ></i>
                            )}
                        </td>

                        <td className="monthly-table-data">
                          {item?.approved_salary}
                        </td>

                        <td className="monthly-table-data">
                          {item.approved_salary !== 0 &&
                            item.status !== "OPS_FREEZED" &&
                            item.status !== "OPS_APPROVED" &&
                            item.status !== "OPS_REJECTED" && (
                              <input
                                type="checkbox"
                                id="vehicle1"
                                name="vehicle1"
                                value="Bike"
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e.target.checked,
                                    item.id
                                  )
                                }
                              />
                            )}
                        </td>
                        <td className="monthly-table-data">
                          <i
                            className="fa fa-inr icon-styling-v1"
                            data-toggle="modal"
                            data-target="#viewPenaltyModalCenter"
                            onClick={() =>
                              handlePenaltyDetailsData(item.user_id, item?.month, item?.year)
                            }
                          ></i>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
              <div className="d-flex" style={{fontSize:"large", justifyContent:"end"}}>
                <ReactPaginate
                  nextLabel=">"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  previousLabel="<"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  forcePage={getValetMonthlyList?.currentPage}
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </div>
            </>
          ) : (
            <div>
              <img src={Images?.NoData} alt="" width="100%" />
            </div>
          )}
        </>

        <ModalPop
          title={"Daily salary distribution"}
          show={dailySalaryModal}
          handleModalHide={handleDailyModalCloseClick}
        >
          <div style={{ overflowX: "auto" }}>
            <table className="table" style={{ width: "100%" }}>
              <tr className="table-heading v3Tab">
                <th>Transaction Date</th>
                <th>Full day</th>
                <th>Half day</th>
                <th>OT hours</th>
                <th>Half day extra hours</th>
                <th>Zero day extra hours</th>
              </tr>

              {getDailySalaryDistribution?.data && Object.keys(getDailySalaryDistribution?.data).length > 0 && getDailySalaryDistribution?.data?.map((item, index) => {
                // Parse the transaction date string
                const transactionDate = new Date(item.transaction_date);

                // Extract day, month, and year
                const day = String(transactionDate.getDate()).padStart(2, "0");
                const month = String(transactionDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const year = transactionDate.getFullYear();

                // Format the date as DD-MM-YYYY
                const formattedDate = `${day}-${month}-${year}`;

                return (
                  <tr key={index}>
                    <td>{formattedDate}</td>
                    <td>{item.full_working_day}</td>
                    <td>{item.half_working_day}</td>
                    <td>{item.overtime_hours}</td>
                    <td>{item.half_day_extra_hours}</td>
                    <td>{item.zero_day_extra_hours}</td>
                  </tr>
                );
              })}
            </table>
          </div>
        </ModalPop>
        <ModalPop
            title={"AE Suggested Penalty Details"}
            show={userMasterPenaltyModal}
            handleModalHide={handleUserPenaltyModalCloseClick}
        >
          <div style={{ overflowX: "auto" }}>
            <table className="table" style={{ width: "100%" }}>
              <tr className="table-heading v3Tab">
                <th>Category</th>
                <th>Sub Category</th>
                <th>Remark</th>
                <th>Url</th>
                <th>Amount</th>
                <th>Requested By</th>
                <th>Requested On</th>
              </tr>

              {masterSalaryPenaltyListResponse?.salary_components_data && Object.keys(masterSalaryPenaltyListResponse?.salary_components_data).length > 0 && masterSalaryPenaltyListResponse?.salary_components_data?.map((item, index) => {
                return (
                    <tr key={index}>
                      <td>{item.category}</td>
                      <td>{item.subcategory}</td>
                      <td>{item.details?.remark}</td>
                      <td>{item.details?.urls}</td>
                      <td>{item.amount}</td>
                      <td>{item.requested_by_role}</td>
                      <td>{item.created_at}</td>
                    </tr>
                );
              })}
            </table>
          </div>
        </ModalPop>
        <ModalPop
          title={"Penalty Details"}
          show={penaltyDetailsModal}
          handleModalHide={handlePenaltyDetailsModalCloseClick}
        >
          <div className="table-container">
        {incentiveList?.grid_data ? (
          <table className="table">
            <thead className="incentive-thead">
              <tr className="table-border">
                <th className="table-border text-center fixed-column">
                </th>
                <th className="table-border text-center fixed-column">
                </th>
                {Object.keys(transposedData).map((earningType, cellIndex) => (
                  <th
                    key={cellIndex}
                    colSpan="2"
                    className="table-border incentive-cell-padding text-center"
                  >
                      {earningType}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="table-body">
              {gridData &&
                gridData.map((rowData, rowIndex) => (
                  <tr key={rowIndex} className="table-border">
                    <td className="table-border incentive-cell-padding incentive-thead fixed-column">
                        <strong>{formatDate(rowData.transaction_date)}</strong>
                    </td>
                    <td className="table-border incentive-cell-padding incentive-thead fixed-column">
                        <strong>{'Total Amount Earned'}</strong>
                    </td>
                    {Object.keys(transposedData).map((rowType, cellIndex) => (
                      <React.Fragment key={cellIndex}>
                        <td
                          colSpan="2"
                          className="table-border incentive-cell-padding"
                        >
                          <div className="parent-style">
                            {rowData.penalties_breakdown_data[rowType] &&
                            rowData.penalties_breakdown_data[rowType].status &&
                            rowData.penalties_breakdown_data[rowType].status !==
                              "NOT_APPLICABLE" ? (
                              <>
                                {/* <input
                                  className="parent-input"
                                  type="checkbox"
                                  id={`amountearned${rowType}${rowIndex}`}
                                  name={`amountearned${rowType}${rowIndex}`}
                                  checked={
                                    rowData.penalties_breakdown_data[rowType]?.is_checked
                                      ? `1`
                                      : ``
                                  }
                                  
                                /> */}
                                <label
                                  htmlFor={`amountearned${rowType}${rowIndex}`}
                                  className="label-new-style"
                                >
                                  
                                      {
                                        rowData.penalties_breakdown_data[rowType]
                                          .total_amount_earned
                                      }
                                    
                                </label>
                              </>
                            ) : (
                              <div className="zero">
                                {
                                  rowData.penalties_breakdown_data[rowType]
                                    .total_amount_earned
                                }
                              </div>
                            )}
                          </div>
                        </td>
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div>
            {/*{localization.noRecord}*/}
            <img src={Images?.NoData} alt="" width="100%" />
          </div>
        )}
      </div>
        </ModalPop>

        <ModalPop
          title={"Calculate Salary"}
          show={calculateSalaryModal}
          handleModalHide={handlesetCalculateSalaryModalHide}
        >
          <div className="text-center">
            {calulateSalary?.data?.calculated_salary ? (
              <h4>
                Your net amount is:{calulateSalary?.data?.calculated_salary}
              </h4>
            ) : null}

            <h5>Once approved, you cannot do any further changes</h5>
          </div>

          <Button
            variant="secondary"
            onClick={handlesetCalculateSalaryModalHide}
          >
            OK
          </Button>
        </ModalPop>

        <ModalPop
          title={"Success"}
          show={isCalculateModal}
          handleModalHide={handleCalculateModalHide}
        >
          {error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{"Salary Calculated Successfully"}</h5>
            </div>
          )}
          <Button variant="secondary" onClick={handleCalculateModalHide}>
            OK
          </Button>
        </ModalPop>

        <ModalPop
          title={"Failed"}
          show={isModalFailed}
          handleModalHide={handleFailedModalHide}
        >
          {error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="text-center">
              <div className="failed">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{"Something went wrong"}</h5>
            </div>
          )}
          <Button variant="secondary" onClick={handleFailedModalHide}>
            OK
          </Button>
        </ModalPop>

        <ModalPop
          title={localization.conf}
          show={isFreezeModal}
          handleModalHide={handleFreezeModalHide}
          keyboard
          backdrop
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{"Are you sure to the freeze salary?"}</h5>
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
              <Button
                onClick={handleFreezeModalHide}
                className="btn btn-danger btn-sm mb-4"
              >
                {localization.no}
              </Button>
              <Button
                onClick={() =>
                  handleCalculateFreeze(freezeId)
                }
                className="btn btn-success btn-sm mb-4"
              >
                {localization.yes}
              </Button>
            </div>
          </div>
        </ModalPop>
      </Layout>
    </>
  );
};
export default MonthlyValetSalary;